import { useState, useEffect } from "react";
import api from "../services/api";

const defaultForm = { username: "", email: "", password: "", role: "operacional" };

export default function Usuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [form, setForm] = useState(defaultForm);
  const [editing, setEditing] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [resetTarget, setResetTarget] = useState(null); // { id, username }
  const [resetSenha, setResetSenha] = useState("");
  const [resetConfirm, setResetConfirm] = useState("");
  const [error, setError] = useState("");
  const [resetError, setResetError] = useState("");
  const [resetOk, setResetOk] = useState("");

  const load = () =>
    api.get("/users").then(({ data }) => setUsuarios(data));

  useEffect(() => { load(); }, []);

  // ── Criar / Editar usuário ────────────────────────────────────────────────
  const save = async (e) => {
    e.preventDefault();
    setError("");
    try {
      if (editing) {
        const payload = {};
        if (form.email) payload.email = form.email;
        if (form.password) payload.password = form.password;
        if (form.role) payload.role = form.role;
        await api.put(`/users/${editing}`, payload);
      } else {
        await api.post("/users", form);
      }
      setShowModal(false);
      setEditing(null);
      setForm(defaultForm);
      load();
    } catch (err) {
      const msg = err.response?.data?.detail;
      setError(typeof msg === "string" ? msg : "Erro ao salvar usuário.");
    }
  };

  const openNew = () => {
    setForm(defaultForm);
    setEditing(null);
    setError("");
    setShowModal(true);
  };

  const openEdit = (u) => {
    setForm({ username: u.username, email: u.email, password: "", role: u.role });
    setEditing(u.id);
    setError("");
    setShowModal(true);
  };

  const toggleStatus = async (u) => {
    if (!window.confirm(`${u.is_active ? "Inativar" : "Ativar"} o usuário "${u.username}"?`)) return;
    try {
      await api.patch(`/users/${u.id}/status`);
      load();
    } catch (err) {
      alert(err.response?.data?.detail || "Erro ao alterar status");
    }
  };

  // ── Redefinir senha (admin → qualquer usuário) ────────────────────────────
  const openReset = (u) => {
    setResetTarget(u);
    setResetSenha("");
    setResetConfirm("");
    setResetError("");
    setResetOk("");
  };

  const submitReset = async (e) => {
    e.preventDefault();
    setResetError("");
    setResetOk("");
    if (resetSenha.length < 6) {
      setResetError("A nova senha deve ter pelo menos 6 caracteres.");
      return;
    }
    if (resetSenha !== resetConfirm) {
      setResetError("As senhas não coincidem.");
      return;
    }
    try {
      await api.post(`/users/${resetTarget.id}/reset-password`, {
        new_password: resetSenha,
      });
      setResetOk(`Senha de "${resetTarget.username}" redefinida com sucesso!`);
      setResetSenha("");
      setResetConfirm("");
    } catch (err) {
      setResetError(err.response?.data?.detail || "Erro ao redefinir senha.");
    }
  };

  const myUsername = localStorage.getItem("username");

  return (
    <div>
      <div className="d-flex justify-content-between mb-3">
        <h4 className="fw-bold mb-0">Usuários do Sistema</h4>
        <button className="btn btn-primary" onClick={openNew}>
          + Novo Usuário
        </button>
      </div>

      <div className="table-responsive">
        <table className="table table-hover align-middle">
          <thead className="table-dark">
            <tr>
              <th>Usuário</th>
              <th>E-mail</th>
              <th>Perfil</th>
              <th>Status</th>
              <th>Criado em</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {usuarios.map((u) => (
              <tr key={u.id}>
                <td className="fw-semibold">
                  {u.username}
                  {u.username === myUsername && (
                    <span className="badge bg-info text-dark ms-2">você</span>
                  )}
                </td>
                <td>{u.email}</td>
                <td>
                  <span className={`badge ${u.role === "admin" ? "bg-danger" : "bg-secondary"}`}>
                    {u.role}
                  </span>
                </td>
                <td>
                  <span className={`badge ${u.is_active ? "bg-success" : "bg-secondary"}`}>
                    {u.is_active ? "Ativo" : "Inativo"}
                  </span>
                </td>
                <td className="text-muted small">
                  {new Date(u.created_at).toLocaleDateString("pt-BR")}
                </td>
                <td>
                  <button
                    className="btn btn-sm btn-outline-primary me-1"
                    onClick={() => openEdit(u)}
                  >
                    Editar
                  </button>
                  <button
                    className="btn btn-sm btn-outline-warning me-1"
                    onClick={() => openReset(u)}
                    title="Redefinir senha"
                  >
                    🔑 Senha
                  </button>
                  {u.username !== myUsername && (
                    <button
                      className={`btn btn-sm ${u.is_active ? "btn-outline-danger" : "btn-outline-success"}`}
                      onClick={() => toggleStatus(u)}
                    >
                      {u.is_active ? "Inativar" : "Ativar"}
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ── Modal: Criar / Editar usuário ── */}
      {showModal && (
        <div className="modal show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {editing ? "Editar Usuário" : "Novo Usuário"}
                </h5>
                <button className="btn-close" onClick={() => setShowModal(false)} />
              </div>
              <form onSubmit={save}>
                <div className="modal-body row g-3">
                  {error && (
                    <div className="col-12">
                      <div className="alert alert-danger py-2">{error}</div>
                    </div>
                  )}

                  <div className="col-12">
                    <label className="form-label">
                      Username {!editing && <span className="text-danger">*</span>}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      required={!editing}
                      disabled={!!editing}
                      value={form.username}
                      onChange={(e) => setForm({ ...form, username: e.target.value })}
                    />
                    {editing && (
                      <small className="text-muted">O username não pode ser alterado.</small>
                    )}
                  </div>

                  <div className="col-12">
                    <label className="form-label">
                      E-mail <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      required
                      value={form.email}
                      onChange={(e) => setForm({ ...form, email: e.target.value })}
                    />
                  </div>

                  <div className="col-12">
                    <label className="form-label">
                      Senha{" "}
                      {!editing ? (
                        <span className="text-danger">*</span>
                      ) : (
                        <small className="text-muted">(deixe em branco para manter)</small>
                      )}
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      required={!editing}
                      minLength={6}
                      placeholder={editing ? "••••••" : "Mínimo 6 caracteres"}
                      value={form.password}
                      onChange={(e) => setForm({ ...form, password: e.target.value })}
                    />
                  </div>

                  <div className="col-12">
                    <label className="form-label">Perfil</label>
                    <select
                      className="form-select"
                      value={form.role}
                      onChange={(e) => setForm({ ...form, role: e.target.value })}
                    >
                      <option value="operacional">Operacional</option>
                      <option value="admin">Admin</option>
                    </select>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Cancelar
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Salvar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* ── Modal: Redefinir senha ── */}
      {resetTarget && (
        <div className="modal show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header bg-warning">
                <h5 className="modal-title">
                  🔑 Redefinir senha — {resetTarget.username}
                </h5>
                <button className="btn-close" onClick={() => setResetTarget(null)} />
              </div>
              <form onSubmit={submitReset}>
                <div className="modal-body row g-3">
                  {resetError && (
                    <div className="col-12">
                      <div className="alert alert-danger py-2">{resetError}</div>
                    </div>
                  )}
                  {resetOk && (
                    <div className="col-12">
                      <div className="alert alert-success py-2">{resetOk}</div>
                    </div>
                  )}

                  <div className="col-12">
                    <label className="form-label fw-semibold">Nova Senha</label>
                    <input
                      type="password"
                      className="form-control"
                      required
                      minLength={6}
                      placeholder="Mínimo 6 caracteres"
                      value={resetSenha}
                      onChange={(e) => setResetSenha(e.target.value)}
                    />
                  </div>

                  <div className="col-12">
                    <label className="form-label fw-semibold">Confirmar Nova Senha</label>
                    <input
                      type="password"
                      className="form-control"
                      required
                      minLength={6}
                      placeholder="Repita a nova senha"
                      value={resetConfirm}
                      onChange={(e) => setResetConfirm(e.target.value)}
                    />
                  </div>

                  <div className="col-12">
                    <small className="text-muted">
                      A nova senha será aplicada imediatamente. Informe o usuário após a redefinição.
                    </small>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setResetTarget(null)}
                  >
                    Fechar
                  </button>
                  <button type="submit" className="btn btn-warning fw-bold">
                    Redefinir Senha
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
